module.exports = __webpack_public_path__ + "img/ouvrages-empty_state.95112e1f.svg";